// Array definitions
const classes = [
  "Forgotten Ronin",
  "Erudite Samurai",
  "Drunken Monk",
  "Corrupted Shinobi",
  "Onmyoji",
  "Bakuto",
  "Yamabushi",
  "Wild Dancer",
  "Reckless Sumo",
  "Sword Saint",
];

const firstNames = [
  "Himura",
  "Daichi",
  "Eiko",
  "Genji",
  "Mizu",
  "Isamu",
  "Toyo",
  "Ryoma",
  "Michiko",
  "Tomoe",
  "Osamu",
  "Rei",
  "Sachi",
  "Saito",
  "Ume",
  "Yori",
  "Zen",
  "Arata",
  "Jiro",
  "Musashi",
];

const lastNames = [
  "Battosai",
  "Chiba",
  "Fujiwara",
  "Hattori",
  "Ito",
  "Matsamune",
  "Sakura",
  "Sakamoto",
  "Okada",
  "Hajime",
  "Takahashi",
  "Uesugi",
  "Yamagata",
  "Yojimbo",
  "Akiyama",
  "Fujimoto",
  "Miyamoto",
  "Ishikawa",
  "Kitano",
  "Matsushita",
];

const nickNames = [
  { english: "Hawk Eye", japanese: "Taka no Me", kanji: "鷹の目" },
  { english: "Dragon of the Sea", japanese: "Umi no Tatsu", kanji: "海の竜" },
  { english: "Thunder Fang", japanese: "Kaminari no Kiba", kanji: "雷の牙" },
  { english: "River God", japanese: "Kawa no Kami", kanji: "川の神" },
  { english: "Mountain Wind", japanese: "Yama no Kaze", kanji: "山の風" },
  {
    english: "Sword Saint of the Wind",
    japanese: "Kaze no Kensei",
    kanji: "風の剣聖",
  },
  { english: "Demon of the Fog", japanese: "Kiri no Oni", kanji: "霧の鬼" },
  { english: "Tiger of Hell", japanese: "Jigoku no Tora", kanji: "地獄の虎" },
  { english: "Fox of the Night", japanese: "Yoru no Kitsune", kanji: "夜の狐" },
  { english: "Black Fang", japanese: "Kuroi Kiba", kanji: "黒い牙" },
  { english: "Tiger Demon", japanese: "Tora no Oni", kanji: "虎の鬼" },
  { english: "Cat's Paw", japanese: "Neko no Te", kanji: "猫の手" },
  { english: "Wind Tengu", japanese: "Kaze no Tengu", kanji: "風の天狗" },
  { english: "Man Slayer", japanese: "Hitokiri", kanji: "人斬り" },
  {
    english: "Knight of Darkness",
    japanese: "Yami no Kishi",
    kanji: "闇の騎士",
  },
  {
    english: "Monster Boss",
    japanese: "Bakemono no Oyabun",
    kanji: "化物の親分",
  },
  { english: "Flower Geisha", japanese: "Hana no Geisha", kanji: "花の芸者" },
  {
    english: "Warrior of Thunder",
    japanese: "Kaminari no Senshi",
    kanji: "雷の戦士",
  },
  {
    english: "Ghostly Wanderer",
    japanese: "Yurei no Tomurai",
    kanji: "幽霊の弔い",
  },
  { english: "Black Shadow", japanese: "Kuroi Kage", kanji: "黒い影" },
];

const carryMap = new Map([
  [1, "Empty-handed"],
  [2, "Empty-handed"],
  [3, "<strong style='color:#ECCF18;'>Backpack</strong> up to 7 small items"],
  [4, "<strong style='color:#ECCF18;'>Sack</strong> up to 10 small items"],
  [5, "<strong style='color:#ECCF18;'>Small wagon</strong>"],
  [6, "<strong style='color:#ECCF18;'>Trusty pack animal</strong>"],
]);

const equipmentMap = new Map([
  [1, "<strong style='color:#ECCF18;'>Rope</strong> 30 ft"],
  [2, "5 <strong style='color:#ECCF18;'>Torches</strong>"],
  [3, "<strong style='color:#ECCF18;'>Lantern</strong> with oil for 6 hours"],
  [4, "<strong style='color:#ECCF18;'>Magnesium strip</strong>"],
  [5, "<strong style='color:#ECCF18;'>An Unseen Text</strong>"],
  [6, "4 <strong style='color:#ECCF18;'>Firecrackers</strong>"],
  [7, "4 <strong style='color:#ECCF18;'>Healers Kits</strong>"],
  [8, "<strong style='color:#ECCF18;'>Metal file and lockpicks</strong>"],
  [
    9,
    "<strong style='color:#ECCF18;'>Bear trap</strong> Spirit DR14 to spot, d8 damage",
  ],
  [10, "<strong style='color:#ECCF18;'>Black powder bomb</strong> d10 damage"],
  [
    11,
    "4 <strong style='color:#ECCF18;'>Snake venom shuriken</strong> Resilience DR12 or d8 damage",
  ],
  [
    12,
    "<strong style='color:#ECCF18;'>Silver talisman</strong> defence DR against yokai DR10",
  ],
]);

const startingWeaponsMap = new Map([
  [1, { name: "Shuriken", damage: "d4", amount: "(x10)" }],
  [2, { name: "Tanto", damage: "d4" }],
  [3, { name: "Yumi", damage: "d6", amount: "(Spirit+10 arrows)" }],
  [4, { name: "Bo Staff", damage: "d6" }],
  [5, { name: "Naginata", damage: "d8" }],
  [6, { name: "Kusarigama", damage: "d6", amount: "(melee/ranged)" }],
  [7, { name: "Wakizashi", damage: "d6" }],
  [8, { name: "Nunchaku", damage: "d6" }],
  [9, { name: "Tanegashima", damage: "d8", amount: "(Spirit+5 bullets)" }],
  [10, { name: "Katana", damage: "d10" }],
]);

const unseenTextsMap = new Map([
  [
    1,
    {
      title: "Whirlwind Blade",
      description:
        "Unleash a flurry (d4) of air strikes against a single enemy, dealing d6 damage per hit.",
    },
  ],
  [
    2,
    {
      title: "Soothing Breeze",
      description: "Heal d6 HP for yourself or an ally.",
    },
  ],
  [
    3,
    {
      title: "Thundering Roar",
      description: "Stun a single enemy for 1 round.",
    },
  ],
  [
    4,
    {
      title: "Eagle Eye",
      description: "Gain +4 to hit for your next attack.",
    },
  ],
  [
    5,
    {
      title: "Shadow Step",
      description: "Instantly move to any visible location.",
    },
  ],
  [
    6,
    {
      title: "Burning Blade",
      description:
        "Ignite your weapon, dealing an extra d4 damage with each hit for d6 rounds.",
    },
  ],
  [
    7,
    {
      title: "Steel Barrier",
      description: "Gain +2 to Swiftness tests for defence for d6 rounds.",
    },
  ],
  [
    8,
    {
      title: "Spectral Guardian",
      description:
        "Summon a skeletal ronin to fight alongside you for d6 rounds.",
    },
  ],
  [
    9,
    {
      title: "Soul Drain",
      description:
        "Deal d8 damage and gain that much HP for yourself (can take you above max HP).",
    },
  ],
  [
    10,
    {
      title: "Void Blast",
      description:
        "Unleash a blast of negative energy that deals d8 damage to all enemies you can see.",
    },
  ],
]);

const shintaiTextsMap = new Map([
  [
    1,
    {
      title: "Blessing of the Gods",
      description: "Restore d10 HP to d2 creatures.",
    },
  ],
  [
    2,
    {
      title: "Grace of Redemption",
      description: "A creature of your choice gains +d6 on one roll.",
    },
  ],
  [
    3,
    {
      title: "Speak with the Departed",
      description: "Ask three questions to a deceased creature.",
    },
  ],
  [
    4,
    {
      title: "Spirit Shield",
      description:
        "A creature of your choice gains 2d6 extra HP for d3 rounds.",
    },
  ],
  [
    5,
    {
      title: "Visions of the Beyond",
      description:
        "One creature, dead for no more than a week, is awakened with terrible memories.",
    },
  ],
  [
    6,
    {
      title: "Bestial Communion",
      description: "You may speak with animals for d20 minutes.",
    },
  ],
  [
    7,
    {
      title: "Divine Illumination",
      description: "Light or darkness for 3d10 minutes.",
    },
  ],
  [
    8,
    {
      title: "Pure Insight",
      description: "You find all traps in your path for 2d10 minutes.",
    },
  ],
  [
    9,
    {
      title: "Holy Retribution",
      description: "d4 creatures lose d8 HP each.",
    },
  ],
  [
    10,
    {
      title: "Word of the Gods",
      description: "One creature blindly obeys a single command.",
    },
  ],
]);

//Att Maps
const brokenBodiesMap = new Map([
  [1, "always staring with a glazed expression"],
  [2, "covered in scars or wounds, some of which are infected"],
  [3, "missing a limb, using a makeshift prosthesis"],
  [4, "emaciated and frail, with sunken eyes and greyish skin"],
  [5, "severely burned on the face and hands, using a mask to hide them"],
  [6, "deaf in one ear, struggling to hear from the other"],
  [7, "missing teeth, some rotten, speaking with a lisp"],
  [8, "crippled, walking with a limp or hunchbacked"],
  [9, "covered in boils or blisters, constantly scratching"],
  [10, "persistently cough and wheezing"],
  [11, "covered in insect bites"],
  [12, "missing your tongue"],
  [
    13,
    "suffering from nervous system damage, making youe hands shake and twitch",
  ],
  [
    14,
    "severely obese or suffering from malnutrition, either way you are always hungry",
  ],
  [15, "missing fingers or toes"],
  [16, "breathing heavily and snoring loudly because of your broken nose"],
  [17, "permanently scowling or smiling, making social interaction difficult"],
  [
    18,
    "suffering from a chronic skin condition, leaving skin flaky or weeping",
  ],
  [19, "blind or suffering from vision problems"],
  [
    20,
    "not very clean, with cracked, discoloured nails and signs of fungal infection",
  ],
]);

const grimChroniclesMap = new Map([
  [1, "fled from a powerful and dangerous clan and are constantly on the run."],
  [2, "have a powerful enemy who wants you dead at all costs."],
  [3, "possess a rare and valuable artifact that is coveted by many."],
  [4, "are under a terrible curse that cannot be lifted."],
  [
    5,
    "once betrayed a close friend and have been wracked with guilt ever since.",
  ],
  [6, "are plagued by haunting visions of a dark future."],
  [7, "have a shadowy past that is slowly catching up with you."],
  [
    8,
    "are haunted by a vengeful spirit that will not rest until it gets what it wants.",
  ],
  [9, "are the only survivor of a massacre that you cannot forget."],
  [10, "have a powerful addiction that is slowly destroying you."],
  [11, "have angered a powerful spirit that is now out for revenge."],
  [
    12,
    "are followed by a strange, unexplainable phenomenon that brings chaos and destruction wherever you go.",
  ],
  [13, "are hunted by a terrifying monster that you cannot defeat."],
  [
    14,
    "are haunted by a dark secret that, if revealed, could destroy everything you hold dear.",
  ],
  [15, "have made a dangerous enemy of an influential clan."],
  [
    16,
    "have made a deal with a malevolent entity that is slowly taking over your mind and body.",
  ],
  [
    17,
    "are cursed with the ability to see the worst in people and cannot help but voice your thoughts.",
  ],
  [
    18,
    "are plagued by unexplainable nightmares that are slowly driving you insane.",
  ],
  [19, "are cursed with an insatiable hunger that can never be sated."],
  [
    20,
    "have been marked by a dark force that will stop at nothing to claim your soul.",
  ],
]);

const badHabitsMap = new Map([
  [
    1,
    "compulsively hoard any small trinkets you come across, often to the detriment of your party.",
  ],
  [2, "have a crippling fear of enclosed spaces or the dark."],
  [
    3,
    "have an urge to speak your mind, even if it means making enemies or getting into trouble.",
  ],
  [
    4,
    "are addicted to a particular substance and go to great lengths to get your fix.",
  ],
  [5, "have a habit of stealing things, even when it's not beneficial."],
  [6, "have anger management issues. Tend to lash out violently."],
  [7, "have chronic insomnia."],
  [
    8,
    "are extremely paranoid. You make up conspiracy theories, even when they have no basis in reality.",
  ],
  [9, "have a terrible memory, often forget important details or information."],
  [10, "are a persistent procrastinator."],
  [11, "are obsessed with counting and arranging objects."],
  [12, "often mmumble to yourself, even in public."],
  [13, "are always losing important items."],
  [14, "need to keep your weapons and tools CLEAN."],
  [15, "tell overly long and irrelevant tales in conversation."],
  [16, "collect ears to whisper secrets into."],
  [17, "are constantly fidgeting. Just can’t sit still."],
  [18, "have a habit of making loud, nervous sneezes."],
  [19, "hate being touched."],
  [20, "cannot help but steal food from everyone then hoard it."],
]);

const awfulAfflictionsMap = new Map([
  [1, "Paranoid."],
  [2, "Sadistic."],
  [3, "Narcissistic."],
  [4, "Compulsive liar."],
  [5, "Self-destructive."],
  [6, "Envious."],
  [7, "Antisocial."],
  [8, "Addicted."],
  [9, "Short-tempered."],
  [10, "Greedy."],
  [11, "Pessimistic."],
  [12, "Manipulative."],
  [13, "Careless."],
  [14, "Aggressive."],
  [15, "Insecure."],
  [16, "Hedonistic."],
  [17, "Fanatical."],
  [18, "Hypocritical."],
  [19, "Unreliable."],
  [20, "Delusional."],
]);

const classFeatures = {
  "Forgotten Ronin": {
    modifiers: {
      swiftness: +2,
      spirit: -2,
      vigor: +2,
      resilience: +2,
      honour: -1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 10)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [{ name: "Worn katana", damage: "d8" }],
    startingEquipment: ["Traveling clothes", "Straw hat"],
    features: new Map([
      [
        1,
        {
          title: "Ronin’s Resolve",
          description:
            "The Forgotten Ronin can draw upon their inner strength and resolve in times of great need. Once per day, they may roll d6 and add the result to any one roll they make.",
        },
      ],
      [
        2,
        {
          title: "Sword Master",
          description:
            "A master of the blade, wielding their sword with deadly precision. They may add their Vigor modifier to damage rolls made with melee weapons.",
        },
      ],
      [
        3,
        {
          title: "Masterless",
          description:
            "If the Forgotten Ronin’s honour score is below 10 they may Parry at DR12.",
        },
      ],
      [
        4,
        {
          title: "Bushi's Blade",
          description:
            "When both the Rōnin and an enemy are wielding a Katana or Wakizashi the attack and defence DR is lowered by 2.",
        },
      ],
      [
        5,
        {
          title: "Protector",
          description:
            "The Forgotten Ronin is fiercely protective of their allies and will go to great lengths to defend them. Once per combat, they may protect an ally, adding +2 to their defence against all attacks until the end of the Ronin’s next turn.",
        },
      ],
      [
        6,
        {
          title: "Haunted Blade",
          description:
            "Once per combat, make a sacrifice to the blade; anything from losing d4 HP to discarding an important item. On the next attack with the blade, roll twice and take the higher roll, the strike deals an extra d8 damage. After the strike, the blade attacks a random target including the Ronin and allies, until the end of the Ronin’s next turn.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Ronin’s Creed",
      tenetsList: [
        "Resilience",
        "Freedom",
        "Personal Mastery",
        "Empathy",
        "Discipline",
        "Dignity",
      ],
    },
  },

  "Erudite Samurai": {
    modifiers: {
      swiftness: -1,
      spirit: -1,
      vigor: +2,
      resilience: +1,
      honour: +2,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(3, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [
      { name: "Fine Katana", damage: "d10" },
      { name: "Wakizashi", damage: "d6" },
    ],
    startingEquipment: ["Collection of books and papers"],
    features: new Map([
      [
        1,
        {
          title: "Scholarly Training",
          description:
            "The Erudite Samurai has received extensive training in the arts of literature, philosophy, and the sciences. If in honourable standing (above 10 Honour) they may add +4 to a damage roll once per day.",
        },
      ],
      [
        2,
        {
          title: "Philosophy of War",
          description:
            "Once per combat, predict the next move of the enemy and gain a +2 bonus to an roll against that opponent. This ability can only be used if they have had at least one round to observe their opponent's fighting style.",
        },
      ],
      [
        3,
        {
          title: "Tactical Genius",
          description:
            " A master of strategy and tactics. They may use their honour score if in honourable standing (Honour 10 or above) to gain an advantage in combat, reducing the DR of a parry to DR12.",
        },
      ],
      [
        4,
        {
          title: "Precise Strike",
          description:
            "Trained to strike with precision, finding the weaknesses in their opponents' defences. Once per combat encounter, they may add a bonus to their attack roll equal to their Vigor modifier.",
        },
      ],
      [
        5,
        {
          title: "Intimidating Presence",
          description:
            "Knowledge and training make them a formidable opponent. Once per day, they can intimidate their enemies, lowering the DR of their next attack by 4.",
        },
      ],
      [
        6,
        {
          title: "Zen Focus",
          description:
            "Once per day, they can enter a state of zen-like focus, granting them a +1 bonus to all ability rolls for a duration of 10 minutes.",
        },
      ],
    ]),
    honourTenets: {
      title: "Bushido",
      tenetsList: [
        "Courage",
        "Honesty",
        "Honour",
        "Loyalty",
        "Self-Control",
        "Self-Sacrifice",
      ],
    },
  },

  "Drunken Monk": {
    modifiers: {
      swiftness: +2,
      spirit: +2,
      vigor: +1,
      resilience: -2,
      honour: -1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 4);
    },
    virtuesDice: "d4",
    weapons: [{ name: "Brass knuckles", damage: "d4" }],
    startingEquipment: [
      "Monk's robes and sandals",
      "<strong style='color:#ECCF18;'>Gourd of sake</strong> d4 uses",
    ],
    features: new Map([
      [
        1,
        {
          title: "Drunken Fist",
          description:
            "The Drunken Monk fights with an unpredictable, fluid style that confounds opponents. They may add their Spirit modifier when making unarmed attacks.",
        },
      ],
      [
        2,
        {
          title: "Five Finger Death Punch",
          description:
            "Once per session, choose to strike an opponent with a precision unarmed attack that targets pressure points, dealing an additional 6d4 on a success and stunning the target.",
        },
      ],
      [
        3,
        {
          title: "Roadhouse",
          description:
            "Make a brutal attack against an opponent's throat potentially killing them outright. Before making an attack, Test Spirit DR14. The attack requires the monk to make a successful attack and may only be used on a surprised opponent.",
        },
      ],
      [
        4,
        {
          title: "Flame Fist",
          description:
            "Knuckles imbued with mystical fire, dealing 1d4 additional fire damage and potentially setting targets on fire. The Monk may only use this ability a limited number of times per day (Spirit +1).",
        },
      ],
      [
        5,
        {
          title: "Sake Style",
          description:
            "When the Drunken Monk is under the effects of alcohol, they gain a temporary +2 bonus to their melee attacks and defence.",
        },
      ],
      [
        6,
        {
          title: "Drunken Master",
          description:
            "Turn any item into a weapon, increasing the damage from a d4 to d6. Additionally, they have a +1 bonus to initiative rolls while drunk.",
        },
      ],
    ]),
    honourTenets: {
      title: "Noble Truths",
      tenetsList: [
        "Simplicity",
        "Harmony",
        "Compassion",
        "Perseverance",
        "Serenity",
        "Honesty",
      ],
    },
  },

  "Corrupted Shinobi": {
    modifiers: {
      swiftness: +2,
      spirit: +2,
      vigor: -1,
      resilience: +1,
      honour: -2,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(2, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [
      { name: "Pair of kusarigama", damage: "d6", amount: "(melee/ranged)" },
      { name: "Shuriken", damage: "d4", amount: "(x10)" },
    ],
    startingEquipment: [
      "Dark, unremarkable clothing",
      "<strong style='color:#ECCF18;'>Small vial of poison</strong> d6 uses, d4 damage for d4 rounds",
    ],
    features: new Map([
      [
        1,
        {
          title: "Corrupted Techniques",
          description:
            "Various forbidden techniques that allow manipulation of shadows and infliction of horrific curses. Once per day, they can choose one of the following effects: create a pool of darkness to hide in or curse an enemy to take ongoing damage (d4 per round).",
        },
      ],
      [
        2,
        {
          title: "Poison Master",
          description:
            "An expert in crafting and applying deadly poisons. They can create one dose of poison during a short rest. Poisons created this way deal an additional d4 damage.",
        },
      ],
      [
        3,
        {
          title: "Smoke Screen",
          description:
            "Once per day, the shinobi can create a dense cloud of smoke that provides cover and obscures vision. The smoke lasts for d6 rounds.",
        },
      ],
      [
        4,
        {
          title: "Betrayer's Blade",
          description:
            "The Corrupted Shinobi carries a blade that is infused with dark magic and has the ability to absorb the life force of their enemies. Once per day, they can use this ability to deal an additional d8 damage and heal themselves for the same amount.",
        },
      ],
      [
        5,
        {
          title: "Shadow Step",
          description:
            "Teleport a short distance by stepping into the shadows. They can use this ability to teleport to a nearby shadowy area. The Shinobi may only use this ability a limited number of times per day (Swiftness +1).",
        },
      ],
      [
        6,
        {
          title: "Dark Illusion",
          description:
            "Once per combat, they can create an illusory double of themselves, causing enemies to attack the wrong target. When the Shinobi is hit, roll a d6; on an even number the enemy hits the Shinobi, on an odd number it hits the illusion causing it to disappear.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Unseen Virtues",
      tenetsList: [
        "Deception",
        "Ruthlessness",
        "Loyalty",
        "Discretion",
        "Adaptability",
        "Perseverance",
      ],
    },
  },

  Onmyoji: {
    modifiers: {
      swiftness: -1,
      spirit: +3,
      vigor: +2,
      resilience: -1,
      honour: 0,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 4);
    },
    virtuesDice: "d4",
    weapons: [{ name: "Kiseru", damage: "d4" }],
    startingEquipment: ["Robes and talismans"],
    features: new Map([
      [
        1,
        {
          title: "Divining Rod",
          description:
            "A rod carved from a sacred tree that vibrates and hums when danger is near. When in use, the rod will point in the direction of any nearby threats. Once per day, the Onmyoji can ask the rod a yes or no question and receive a clear answer.",
        },
      ],
      [
        2,
        {
          title: "Ofuda Talisman",
          description:
            "A sheet of paper inscribed with protective symbols that can be used to ward off evil spirits or curses. The talisman can be used once per day to protect against a single supernatural attack or effect. Test Spirit DR12 to activate the talisman and negate the effect.",
        },
      ],
      [
        3,
        {
          title: "Spirit Beacon",
          description:
            "Once per day, create a glowing beacon that draws enemies towards it. Test Spirit DR12. On a success, all enemies in the area are drawn to the beacon, distracting them from attacking the Onmyoji. On a fail, the beacon attracts all enemies to the Onmyoji. The beacon lasts for d6 rounds.",
        },
      ],
      [
        4,
        {
          title: "Shadow Binding",
          description:
            "Attempt to bind an enemy to its shadow, rendering them immobile. To use this ability, Test Spirit DR12. On a success, the enemy is unable to move until the end of the Onmyoji's next turn. The Onmyoji may only use this ability a limited number of times per day (Spirit +1).",
        },
      ],
      [
        5,
        {
          title: "Text of Exorcism",
          description:
            "A text containing powerful incantations and symbols that can be used to banish evil spirits or demons. Once per day, the Onmyoji must Test Spirit DR14 to activate the text, which can banish a single spirit or demon (cannot be used in Yomi).",
        },
      ],
      [
        6,
        {
          title: "Mirror of Reflection",
          description:
            "A handheld mirror inscribed with runes that can be used to reflect hostile spells or attacks. Once per day, Test Spirit DR12 to use the mirror, reflecting any spell or attack directed at them. This deals the attack’s damage back to the attacker.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Rules of the Divine",
      tenetsList: [
        "Respect for Nature",
        "Balance",
        "Wisdom",
        "Compassion",
        "Patience",
        "Perseverance",
      ],
    },
  },

  Bakuto: {
    modifiers: {
      swiftness: -2,
      spirit: +2,
      vigor: +2,
      resilience: -1,
      honour: +1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 10)),
    rollRyo: () => {
      return rollDice(3, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 4);
    },
    virtuesDice: "d4",
    weapons: [{ name: "Tanto", damage: "d4" }],
    startingEquipment: [
      "Stylish, flamboyant clothing",
      "Loaded dice and marked cards",
    ],
    features: new Map([
      [
        1,
        {
          title: "Gambling Luck",
          description:
            "Bakuto can sense when a game is rigged, or someone is cheating. They get +2 to Spirit tests when gambling or playing games of chance. They can also re-roll any one roll, once per day.",
        },
      ],
      [
        2,
        {
          title: "Sucker Punch",
          description:
            "Take a swing before they know what hit ‘em. Deal double damage with their first strike in a round.",
        },
      ],
      [
        3,
        {
          title: "Dirty Tricks",
          description:
            "Pull a fast one to gain the advantage. Once per combat, add +2 to any attack or defence roll by using deception, trickery or surprise.",
        },
      ],
      [
        4,
        {
          title: "Sleight of Hand",
          description:
            "The art of pickpocketing, intimidation, and thievery. They get +4 to Spirit tests when attempting these actions.",
        },
      ],
      [
        5,
        {
          title: "Double Strike",
          description:
            "A master of dual wielding. Make two melee attacks in a single turn, but each attack suffers a -2 penalty to the attack roll.",
        },
      ],
      [
        6,
        {
          title: "Feint",
          description:
            "Choose to forgo their attack on their turn and instead Test Spirit DR10. If successful, the Bakuto gains a +4 to their next attack also dealing +4 damage.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Gambler’s Way",
      tenetsList: [
        "Honour Among Thieves",
        "Resourcefulness",
        "Bravery",
        "Self-Reliance",
        "Camaraderie",
        "Adaptability",
      ],
    },
  },

  Yamabushi: {
    modifiers: {
      swiftness: +1,
      spirit: +2,
      vigor: -1,
      resilience: +1,
      honour: +1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 4);
    },
    virtuesDice: "d4",
    weapons: [{ name: "Bo Staff", damage: "d6" }],
    startingEquipment: ["Robes and sash adorned with pom-poms"],
    features: new Map([
      [
        1,
        {
          title: "Mountain's Resolve",
          description:
            "Once per day, draw upon the spiritual energy of the mountains to gain a +4 bonus to a roll.",
        },
      ],
      [
        2,
        {
          title: "Spiritual Martial Arts",
          description:
            "Trained in a unique form of martial arts that channels spiritual energy. Once per combat, add their Spirit modifier to an attack or defence roll.",
        },
      ],
      [
        3,
        {
          title: "Mountain's Fury",
          description:
            "Once per combat, channel the wrath of the mountains into a powerful strike, dealing an additional d6 damage.",
        },
      ],
      [
        4,
        {
          title: "Ascetic's Wisdom",
          description:
            "Years of solitude have given deep insight. Once per day, may reroll a failed Spirit test.",
        },
      ],
      [
        5,
        {
          title: "Divine Guidance",
          description:
            "Call upon the spirits for guidance and protection. Once per day, perform a ritual to seek divine guidance, granting a temporary +2 bonus to one ability for the next hour.",
        },
      ],
      [
        6,
        {
          title: "Mystic's Shield",
          description:
            "Once per day, use spiritual energy to shield from harm, reducing the damage of an incoming attack to zero.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Yamabushi’s Path",
      tenetsList: [
        "Enlightenment",
        "Harmony",
        "Healing",
        "Exorcism",
        "Discipline",
        "Tradition",
      ],
    },
  },

  "Wild Dancer": {
    modifiers: {
      swiftness: -1,
      spirit: +2,
      vigor: +2,
      resilience: -2,
      honour: -1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [
      { name: "Katana", damage: "d8" },
      { name: "Tanegashima", damage: "d8", amount: "(Spirit+5 bullets)" },
    ],
    startingEquipment: ["Flashy, decorative kimono"],
    features: new Map([
      [
        1,
        {
          title: "Untamed Ferocity",
          description:
            "Once per combat, enter a state of untamed ferocity for rounds equal to Vigor modifier. +1 bonus to attack/defence, matchlock pistol deals additional d4 damage. No Parry ability during this state.",
        },
      ],
      [
        2,
        {
          title: "Two-Weapon Fighting",
          description:
            "Skilled in fighting with a weapon in each hand. Once per day, attack twice in a round with both gun and katana.",
        },
      ],
      [
        3,
        {
          title: "Dancing Defence",
          description:
            "Use graceful movements to dodge attacks. Once per day, dodge an attack that would have hit.",
        },
      ],
      [
        4,
        {
          title: "Shooting Star",
          description:
            "Once per combat, perform a flashy attack with the pistol, reducing DR to attack that enemy by 4 for the next round.",
        },
      ],
      [
        5,
        {
          title: "Sword Dance",
          description:
            "Once per day, unleash a flurry of sword strikes, dealing an extra 2d6 damage.",
        },
      ],
      [
        6,
        {
          title: "Wild Spirit",
          description:
            "Unpredictable nature makes it hard for enemies to anticipate actions. Once per combat, reroll a failed attack or defence roll.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Dancer’s Code",
      tenetsList: [
        "Expression",
        "Rhythm",
        "Passion",
        "Grace",
        "Courage",
        "Innovation",
      ],
    },
  },

  "Reckless Sumo": {
    modifiers: {
      swiftness: -2,
      spirit: -1,
      vigor: +3,
      resilience: +2,
      honour: +1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 12)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [{ name: "Hand chalk", damage: "d8" }],
    startingEquipment: ["Traditional Sumo clothing"],
    features: new Map([
      [
        1,
        {
          title: "Iron Body",
          description:
            "A Sumo’s body is like a fortress. Once per day, they may shrug off an attack that would have damaged them.",
        },
      ],
      [
        2,
        {
          title: "Sumo Slam",
          description:
            "Uses superior strength and mass to deliver a powerful slam attack. Once per combat, add twice Vigor modifier to a melee attack roll.",
        },
      ],
      [
        3,
        {
          title: "Mountain's Grasp",
          description:
            "Roll 2d6+Vigor. If higher than target's morale, they are grappled, unable to attack/move until start of Sumo’s next turn. Ends early if Sumo moved or unconscious.",
        },
      ],
      [
        4,
        {
          title: "Ring Out",
          description:
            "Once per combat, push an enemy out of the immediate combat zone, stopping them from melee attacks for a round.",
        },
      ],
      [
        5,
        {
          title: "Chanko Power",
          description:
            "Incredible strength from diet of chanko nabe. Once per day, tap into this power for a +6 on any Vigor test.",
        },
      ],
      [
        6,
        {
          title: "Belly Bump",
          description:
            "Use girth to bump an opponent, potentially knocking them off balance. Next round, attacks against this enemy are made at +4.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Sumo’s Oath",
      tenetsList: [
        "Endurance",
        "Strength",
        "Patience",
        "Respect",
        "Discipline",
        "Tradition",
      ],
    },

    foodConsumption: "The Sumo consumes 2 Food when resting instead of 1",
  },

  "Sword Saint": {
    modifiers: {
      swiftness: +2,
      spirit: -1,
      vigor: +2,
      resilience: +1,
      honour: +1,
    },
    calculateHitPoints: (abilities) =>
      Math.max(1, abilities.resilience + rollDice(1, 8)),
    rollRyo: () => {
      return rollDice(1, 6) * 10;
    },
    rollVirtues: () => {
      return rollDice(1, 2);
    },
    virtuesDice: "d2",
    weapons: [{ name: "Odachi", damage: "d10" }],
    startingEquipment: ["Empty-handed"],
    features: new Map([
      [
        1,
        {
          title: "Artful Execution",
          description:
            "Master of weapon, capable of precision strikes, ignoring opponent's armour or defences once per combat.",
        },
      ],
      [
        2,
        {
          title: "Unyielding Focus",
          description:
            "Heightened concentration in battle, reducing all incoming damage by half for one round, once per combat.",
        },
      ],
      [
        3,
        {
          title: "Blade's Spirit",
          description:
            "Once per session, pour spirit into a strike, adding Honour score to the damage roll.",
        },
      ],
      [
        4,
        {
          title: "Ancestral Weapon",
          description:
            "Weapon passed down through generations. Once per day, call upon ancestral spirits for a reroll on attack roll.",
        },
      ],
      [
        5,
        {
          title: "Harmonic Duel",
          description:
            "Predict opponent's move in a duel, gaining advantage on next attack, defence, or riposte, once per duel.",
        },
      ],
      [
        6,
        {
          title: "Unyielding Discipline",
          description:
            "Intimidate enemies, lowering DR of next attack by -4, once per day.",
        },
      ],
    ]),
    honourTenets: {
      title: "The Sword Saint’s Discipline",
      tenetsList: [
        "Precision",
        "Mastery",
        "Discipline",
        "Valour",
        "Respect",
        "Legacy",
      ],
    },
  },
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// Utility functions
function getRandomItem(array) {
  return array[Math.floor(Math.random() * array.length)];
}

// Function to roll dice
function rollDice(numberOfDice, sides) {
  let total = 0;
  for (let i = 0; i < numberOfDice; i++) {
    total += Math.floor(Math.random() * sides) + 1;
  }

  // Apply honor modifier for ability rolls (3 dice)
  if (numberOfDice === 3) {
    if (honourState === "honourable") {
      console.log("Original total:", total, "+ 1 for being honourable");
      total += 1;
    } else if (honourState === "dishonourable") {
      console.log("Original total:", total, "- 1 for being dishonourable");
      total -= 1;
    }
  }
  return total;
}

function getAbilityModifier(score) {
  // Return the modifier based on the score
  if (score <= 4) return -3;
  if (score <= 6) return -2;
  if (score <= 8) return -1;
  if (score <= 12) return 0;
  if (score <= 14) return 1;
  if (score <= 16) return 2;
  return 3;
}

let honourState = "none"; // Possible values: 'none', 'honourable', 'dishonourable'

document.addEventListener("DOMContentLoaded", function () {
  document
    .getElementById("honourableButton")
    .addEventListener("click", () => toggleHonourState("honourable"));
  document
    .getElementById("dishonourableButton")
    .addEventListener("click", () => toggleHonourState("dishonourable"));
  // ... other initialization code
});

function toggleHonourState(state) {
  if (honourState === state) {
    honourState = "none";
  } else {
    honourState = state;
  }
  updateButtonStyles();
}

function updateButtonStyles() {
  document.getElementById("honourableButton").style.color =
    honourState === "honourable" ? "#ECCF18" : "white";
  document.getElementById("honourableButton").style.borderColor =
    honourState === "honourable" ? "#ECCF18" : "white";

  document.getElementById("dishonourableButton").style.color =
    honourState === "dishonourable" ? "#FF4040" : "white";
  document.getElementById("dishonourableButton").style.borderColor =
    honourState === "dishonourable" ? "#FF4040" : "white";
}

function getRandomUnseenText() {
  // This should refer to your actual unseen texts data structure
  // For the example, I'm assuming it's a Map similar to what we've created earlier
  const unseenTextRoll = rollDice(1, unseenTextsMap.size); // Roll based on the size of unseen texts
  return unseenTextsMap.get(unseenTextRoll); // Get the unseen text based on the roll
}

function determineArmorBasedOnRoll(roll) {
  const armorsByRoll = {
    1: [
      {
        style: "No Armour",
        tier: 0,
        description: "Leaves you vulnerable to all attacks. Good luck…",
      },
    ],
    2: [
      {
        style: "Ashigaru Armour",
        tier: 1,
        description:
          "Light Armour with moderate protection. Reduces damage taken by -d2.",
      },
      {
        style: "Kendo Armour",
        tier: 1,
        description:
          "Light Armour, cloth and padded. Reduces damage taken by -d2.",
      },
    ],
    3: [
      {
        style: "Do-maru",
        tier: 2,
        description:
          "Medium Armour, iron or leather plates. Reduces damage taken by -d4, +2 DR penalty on Swiftness.",
      },
      {
        style: "Kusari Armour",
        tier: 2,
        description:
          "Medium Armour, interlocking metal rings. Reduces damage taken by -d4, +2 DR penalty on Swiftness.",
      },
    ],
    4: [
      {
        style: "O-yoroi",
        tier: 3,
        description:
          "Heavy Armour, iron plates and chainmail. Reduces damage taken by -d6, +4 DR penalty on Swiftness.",
      },
      {
        style: "Haramaki",
        tier: 3,
        description:
          "Heavy Armour, leather and iron plates. Reduces damage taken by -d6, +4 DR penalty on Swiftness.",
      },
    ],
  };

  // Select a random armor from the tier array based on the roll
  let tierArmors = armorsByRoll[roll];
  if (!tierArmors) {
    console.error("Invalid roll for armor:", roll);
    // Default to the first entry (No Armour) if the roll is invalid
    return armorsByRoll[1][0];
  }
  return tierArmors[Math.floor(Math.random() * tierArmors.length)];
}

function rollForArmor(hasText) {
  // Roll a d2 if the character has a Text, otherwise roll a d4
  console.log("Has Text for Armor Roll:", hasText);
  return rollDice(1, hasText ? 2 : 4);
}

function clearCharacterDisplay() {
  document.getElementById("characterName").innerText = "";
  document.getElementById("characterNickNameEnglish").innerText = "";
  document.getElementById("characterHitPoints").innerText = "";
  document.getElementById("characterVirtues").innerText = "";
  document.getElementById("characterClass").innerText = "";
  document.getElementById("characterAtt").innerText = "";
  document.getElementById("characterHonor").innerText = "";
  document.getElementById("characterRyo").innerText = "";
  document.getElementById("characterEquipment").innerHTML = "";
  document.getElementById("characterArmor").innerText = "";
  document.getElementById("featureTitle").innerText = "";
  document.getElementById("featureDescription").innerText = "";
  document.getElementById("unseenTextTitle").innerText = "";
  document.getElementById("unseenTextDescription").innerText = "";
  document.getElementById("shintaiTextTitle").innerText = "";
  document.getElementById("shintaiTextDescription").innerText = "";
}

function rollForEquipment(equipmentMap, selectedClass) {
  let roll;
  let equipment;
  do {
    roll = rollDice(1, equipmentMap.size);
    equipment = equipmentMap.get(roll);

    // Check if the equipment is one of the special items
    if (
      equipment === "4 <strong style='color:#ECCF18;'>Firecrackers</strong>" ||
      equipment === "4 <strong style='color:#ECCF18;'>Healers Kits</strong>" ||
      equipment ===
        "4 <strong style='color:#ECCF18;'>Snake venom shuriken</strong>"
    ) {
      let quantity = rollDice(1, 4); // Roll a d4 for quantity
      equipment = equipment.replace("4", quantity.toString()); // Replace the placeholder '4' with the rolled quantity
    }

    // Repeat roll if the class should not receive an Unseen Text and one is rolled.
  } while (
    (selectedClass === "Onmyoji" || selectedClass === "Yamabushi") &&
    equipment === "An Unseen Text"
  );
  return equipment;
}

function rollForStartingWeapon() {
  const weaponRoll = rollDice(1, startingWeaponsMap.size); // Roll based on the size of startingWeaponsMap
  return startingWeaponsMap.get(weaponRoll); // Get the weapon based on the roll
}

// Function to generate a random character
function generateCharacter() {
  // Clear previous character data
  clearCharacterDisplay();

  // Step 1: Select class
  let selectedClass = getRandomItem(classes);
  let classMods = classFeatures[selectedClass].modifiers;

  // Step 2: Generate basic character attributes
  let firstName = getRandomItem(firstNames);
  let lastName = getRandomItem(lastNames);
  let nickName = getRandomItem(nickNames);

  // Step 3: Calculate abilities
  let abilities = {
    swiftness: getAbilityModifier(rollDice(3, 6) + classMods.swiftness),
    spirit: getAbilityModifier(rollDice(3, 6) + classMods.spirit),
    vigor: getAbilityModifier(rollDice(3, 6) + classMods.vigor),
    resilience: getAbilityModifier(rollDice(3, 6) + classMods.resilience),
    honour: rollDice(3, 6) + classMods.honour,
  };

  // Step 4: Determine hit points
  let hitPoints = Math.max(
    1,
    classFeatures[selectedClass].calculateHitPoints(abilities)
  );

  // Step 5: Assign honor status
  let honorStatus = abilities.honour >= 10 ? "Honourable" : "Dishonourable";

  // Step 6: Generate equipment and texts
  let equipment = classFeatures[selectedClass].startingEquipment.slice(); // Use slice to copy array
  let randomCarry = rollForEquipment(carryMap);
  equipment.push(randomCarry);

  let randomEquipmentRoll = rollDice(1, equipmentMap.size);
  let randomEquipment = rollForEquipment(equipmentMap, selectedClass);

  // Check for random equipment
  let texts = [];

  // Add food and water
  let food = rollDice(1, 4); // Rolls a d4 for food
  let water = rollDice(1, 4); // Rolls a d4 for water
  equipment.push(`${food} <strong style='color:#ECCF18;'>Food</strong>`);
  equipment.push(`${water} <strong style='color:#ECCF18;'>Water</strong>`);

  //Get Starting Weapon

  // Step 7: Determine armor
  let hasSpecialEquipment =
    equipment.includes(
      "<strong style='color:#ECCF18;'>An Unseen Text</strong>"
    ) || equipment.includes("A Shintai Text");

  let armor;
  if (selectedClass === "Erudite Samurai") {
    // Erudite Samurai always gets tier 2 armor
    armor = {
      style: "Do-maru",
      tier: 2,
      description:
        "Medium Armour, iron or leather plates. Reduces damage taken by -d4, +2 DR penalty on Swiftness.",
    };
  } else if (selectedClass === "Sword Saint") {
    // Sword Saint always gets tier 3 armor
    armor = {
      style: "O-yoroi",
      tier: 3,
      description:
        "Heavy Armour, iron plates and chainmail. Reduces damage taken by -d6, +4 DR penalty on Swiftness.",
    };
  } else if (hasSpecialEquipment) {
    // Characters with special equipment roll a d2 for armor
    armor = determineArmorBasedOnRoll(rollDice(1, 2));
  } else {
    // Other characters roll a d4 for armor
    armor = determineArmorBasedOnRoll(rollDice(1, 4));
  }

  // Step 8: Select a feature
  let featureRoll = rollDice(1, 6); // Simulates rolling a d6
  let selectedFeature = classFeatures[selectedClass].features.get(featureRoll);

  // Step 9: Roll for additional attributes
  let brokenBodies = brokenBodiesMap.get(rollDice(1, 20));
  let grimChronicles = grimChroniclesMap.get(rollDice(1, 20));
  let badHabits = badHabitsMap.get(rollDice(1, 20));
  let awfulAfflictions = awfulAfflictionsMap.get(rollDice(1, 20));

  // Logging for debugging
  console.log("Selected class:", selectedClass);
  console.log("Generated character abilities:", abilities);
  console.log("Selected feature:", selectedFeature.title);

  let classWeapons = classFeatures[selectedClass].weapons.slice();
  let otherEquipment = classFeatures[selectedClass].startingEquipment.slice();
  let randomStartingWeapon = rollForStartingWeapon();

  // Step 10: Create character object
  let character = {
    class: selectedClass,
    firstName,
    lastName,
    nickName,
    abilities,
    hitPoints,
    honor: abilities.honour,
    honorStatus,
    ryo: classFeatures[selectedClass].rollRyo(),
    virtues: classFeatures[selectedClass].rollVirtues(),
    virtuesDice: classFeatures[selectedClass].virtuesDice,
    feature: selectedFeature,
    equipment,
    texts,
    honourTenets: classFeatures[selectedClass].honourTenets,
    armor,
    classWeapons,
    otherEquipment,
    brokenBodies,
    grimChronicles,
    badHabits,
    awfulAfflictions,
  };

  character.classWeapons.push(randomStartingWeapon);

  if (
    randomEquipment === "<strong style='color:#ECCF18;'>An Unseen Text</strong>"
  ) {
    equipment.push("<strong style='color:#ECCF18;'>An Unseen Text</strong>"); // Add placeholder text to the equipment list

    // Now pick a random unseen text
    let unseenTextKey = rollDice(1, unseenTextsMap.size);
    let unseenText = unseenTextsMap.get(unseenTextKey);

    // Store the random unseen text in the character object
    character.randomUnseenText = unseenText;
  } else {
    equipment.push(randomEquipment);
  }

  if (selectedClass === "Yamabushi") {
    let unseenTextRoll = rollDice(1, unseenTextsMap.size);
    let unseenText = unseenTextsMap.get(unseenTextRoll);
    character.unseenText = unseenText;
    console.log("Assigned Unseen Text:", character.unseenText); // This should log the text
  }

  if (selectedClass === "Onmyoji") {
    let unseenTextKey = rollDice(1, unseenTextsMap.size);
    let shintaiTextKey = rollDice(1, shintaiTextsMap.size);

    let unseenText = unseenTextsMap.get(unseenTextKey);
    let shintaiText = shintaiTextsMap.get(shintaiTextKey);

    character.unseenText = unseenText;
    character.shintaiText = shintaiText;

    console.log("Assigned Unseen Text for Onmyoji:", character.unseenText);
    console.log("Assigned Shintai Text for Onmyoji:", character.shintaiText);
  }

  if (selectedClass === "Reckless Sumo") {
    character.classFeatures = {
      foodConsumption: "Consumes 2 food when resting instead of 1",
    };
  }
  console.log("Generated Abilities:", abilities);

  console.log("About to display character", character);

  // Step 11: Display the character
  displayCharacter(character);
}

// Function to display the character's information
function displayCharacter(character) {
  // Create an HTML list for the equipment if not empty handed
  let equipmentListHtml = "<ul>";
  let hasEquipment = false;

  for (let item of character.equipment) {
    if (item !== "Empty-handed") {
      equipmentListHtml += `<li>${item}</li>`;
      hasEquipment = true;
    }
  }

  equipmentListHtml += "</ul>";

  if (!hasEquipment) {
    // If no equipment, set the HTML to an empty string or a placeholder message
    document.getElementById("characterEquipment").innerHTML = "";
  } else {
    // Display the list with equipment
    document.getElementById("characterEquipment").innerHTML = equipmentListHtml;
  }

  // For each ability, calculate the symbol and set the text of the corresponding UI element
  let swiftnessSymbol =
    character.abilities.swiftness > 0
      ? "+"
      : character.abilities.swiftness < 0
      ? "-"
      : "±";
  document.getElementById(
    "swiftnessText"
  ).innerText = `${swiftnessSymbol}${Math.abs(character.abilities.swiftness)}`;

  let spiritSymbol =
    character.abilities.spirit > 0
      ? "+"
      : character.abilities.spirit < 0
      ? "-"
      : "±";
  document.getElementById("spiritText").innerText = `${spiritSymbol}${Math.abs(
    character.abilities.spirit
  )}`;

  let vigorSymbol =
    character.abilities.vigor > 0
      ? "+"
      : character.abilities.vigor < 0
      ? "-"
      : "±";
  document.getElementById("vigorText").innerText = `${vigorSymbol}${Math.abs(
    character.abilities.vigor
  )}`;

  let resilienceSymbol =
    character.abilities.resilience > 0
      ? "+"
      : character.abilities.resilience < 0
      ? "-"
      : "±";
  document.getElementById(
    "resilienceText"
  ).innerText = `${resilienceSymbol}${Math.abs(
    character.abilities.resilience
  )}`;

  // Assuming 'honour' is displayed elsewhere and doesn't need a symbol

  let attributesText = "";

  // Add each attribute followed by a newline character
  attributesText += "You are " + character.brokenBodies;
  attributesText += " and " + character.badHabits + "\n";
  attributesText += "\n" + character.awfulAfflictions;
  attributesText += " You " + character.grimChronicles;

  document.getElementById("characterAtt").innerText = attributesText;
  document.getElementById(
    "characterName"
  ).innerText = `${character.firstName} ${character.lastName}`;
  document.getElementById(
    "characterNickNameEnglish"
  ).innerText = `"${character.nickName.english}"`;
  document.getElementById(
    "characterNickNameJapanese"
  ).innerText = `${character.nickName.japanese}`;
  document.getElementById(
    "characterNickNameKanji"
  ).innerText = `${character.nickName.kanji}`;
  document.getElementById(
    "characterHitPoints"
  ).innerText = `${character.hitPoints}`;
  document.getElementById(
    "characterVirtues"
  ).innerText = `${character.virtues} (${character.virtuesDice})`;
  document.getElementById("characterClass").innerText = `${character.class}`;
  document.getElementById("characterAtt").innerText = attributesText;
  document.getElementById(
    "characterHonor"
  ).innerText = `${character.honor} (${character.honorStatus})`;
  document.getElementById("characterRyo").innerText = `${character.ryo}`;
  document.getElementById("characterEquipment").innerHTML = equipmentListHtml;
  document.getElementById("characterArmor").innerText = character.armor.style;
  document.getElementById("characterArmorTier").innerText =
    character.armor.tier.toString();
  document.getElementById("characterArmorDescription").innerText =
    character.armor.description;
  document.getElementById("featureTitle").innerText = character.feature.title;
  document.getElementById("featureDescription").innerText =
    character.feature.description;

  let tenetsText = character.honourTenets.tenetsList.join(" • ");
  document.getElementById("tenetsTitle").innerText =
    character.honourTenets.title;
  document.getElementById("tenetsList").innerText = tenetsText;

  let weaponsListHtml =
    "<ul style='font-family: Overlock; font-size: 16px; font-weight: normal;'>";
  character.classWeapons.forEach((weapon) => {
    let weaponDetailDisplay = weapon.damage;
    if (weapon.amount) {
      weaponDetailDisplay += `, ${weapon.amount}`; // Append amount if it exists
    }
    weaponsListHtml += `<li style='margin-bottom: 3px;'><strong style='color:#ECCF18;'>${weapon.name}</strong> ${weaponDetailDisplay}</li>`;
  });
  weaponsListHtml += "</ul>";

  let fullArmour = `${
    character.armor.style
  }, (armour tier ${character.armor.tier.toString()})`;

  // Check if there is at least one weapon in the classWeapons array
  if (character.classWeapons.length > 0 && character.classWeapons[0].name) {
    document.getElementById("firstWeaponName").innerText =
      character.classWeapons[0].name;
  } else {
    document.getElementById("firstWeaponName").innerText = "";
  }
  if (character.classWeapons.length > 0 && character.classWeapons[0].damage) {
    document.getElementById("firstWeaponDamage").innerText =
      character.classWeapons[0].damage;
  } else {
    document.getElementById("firstWeaponDamage").innerText = "";
  }
  if (character.classWeapons.length > 0 && character.classWeapons[0].amount) {
    document.getElementById("firstWeaponAmount").innerText =
      character.classWeapons[0].amount;
  } else {
    document.getElementById("firstWeaponAmount").innerText = "";
  }
  if (character.classWeapons.length > 1 && character.classWeapons[1].name) {
    document.getElementById("secondWeaponName").innerText =
      character.classWeapons[1].name;
  } else {
    document.getElementById("secondWeaponName").innerText = "";
  }
  if (character.classWeapons.length > 1 && character.classWeapons[1].damage) {
    document.getElementById("secondWeaponDamage").innerText =
      character.classWeapons[1].damage;
  } else {
    document.getElementById("secondWeaponDamage").innerText = "";
  }
  if (character.classWeapons.length > 1 && character.classWeapons[1].amount) {
    document.getElementById("secondWeaponAmount").innerText =
      character.classWeapons[1].amount;
  } else {
    document.getElementById("secondWeaponAmount").innerText = "";
  }

  let isAnyTextAvailable = false;

  if (character.unseenText) {
    document.getElementById("unseenTextTitle").innerText =
      character.unseenText.title;
    document.getElementById("unseenTextDescription").innerText =
      character.unseenText.description;
    document.getElementById("unseenTextColumn").style.display = "block";
    isAnyTextAvailable = true;
  } else if (character.randomUnseenText) {
    // This block will display the random unseen text
    document.getElementById("unseenTextTitle").innerText =
      character.randomUnseenText.title;
    document.getElementById("unseenTextDescription").innerText =
      character.randomUnseenText.description;
    document.getElementById("unseenTextColumn").style.display = "block";
    isAnyTextAvailable = true;
  } else {
    // Clear the text if no unseen text is available
    document.getElementById("unseenTextTitle").innerText = "";
    document.getElementById("unseenTextDescription").innerText = "";
    document.getElementById("unseenTextColumn").style.display = "none";
  }

  // Check and display Shintai Text
  if (character.shintaiText) {
    document.getElementById("shintaiTextTitle").innerText =
      character.shintaiText.title;
    document.getElementById("shintaiTextDescription").innerText =
      character.shintaiText.description;
    document.getElementById("shintaiTextColumn").style.display = "block";
    isAnyTextAvailable = true;
  } else {
    // Clear the text if no shintai text is available
    document.getElementById("shintaiTextTitle").innerText = "";
    document.getElementById("shintaiTextDescription").innerText = "";
    document.getElementById("shintaiTextColumn").style.display = "none";
  }

  if (isAnyTextAvailable) {
    document.getElementById("textTitleStrip").style.display = "block";
  } else {
    document.getElementById("textTitleStrip").style.display = "none";
  }

  if (character.class === "Reckless Sumo") {
    document.getElementById(
      "specialRules"
    ).innerText = `${character.classFeatures.foodConsumption}`;
  } else {
    document.getElementById("specialRules").innerText = ""; // Clear if not a Sumo or no special rules
  }

}

document.addEventListener("DOMContentLoaded", function () {
  generateCharacter();
  document.getElementById("generate").addEventListener("click", function () {
    generateCharacter();
  });
});
